var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 24,
    height: 24,
    transform: "translate(454 198)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 17.213,
    height: 17.177,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_61",
    "data-name": "Mask Group 61",
    transform: "translate(-454 -198)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(457.393 201.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M15.5,39.23a6.991,6.991,0,0,0-2.364-5.357.911.911,0,0,1-.349-.961.846.846,0,0,1,1.383-.419,8.4,8.4,0,0,1,1.894,2.278,8.664,8.664,0,0,1-5.287,12.675,8.519,8.519,0,0,1-9.547-4,8.434,8.434,0,0,1,.549-9.567A10.12,10.12,0,0,1,3,32.556a.835.835,0,0,1,1.223.031.857.857,0,0,1-.075,1.24A6.932,6.932,0,0,0,7.46,45.893a6.841,6.841,0,0,0,7.925-5.636c.064-.389.088-.785.114-1.027",
    transform: "translate(0 -30.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M146.39,4.341c0,1.14.006,2.28,0,3.42a.851.851,0,0,1-1.132.829.839.839,0,0,1-.573-.752c-.01-.207-.005-.416-.005-.623,0-2.079,0-4.157,0-6.236a1.28,1.28,0,0,1,.113-.54.826.826,0,0,1,.94-.415.845.845,0,0,1,.652.837c.006,1.16,0,2.32,0,3.48",
    transform: "translate(-136.913 0)",
    fill: "#0a64f9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.2d672f26c13485f46dc0838a43beee78.svg";
export { ForwardRef as ReactComponent };